import React from "react";
import { Row, Col } from "antd";
import { useTranslation, Trans } from "react-i18next";

import "../../../../assets/survey.scss";

const SurveyStepOneRender = ({ handleChangeChooseList, purposeList, stepOneChooseList }) => {
  const { t } = useTranslation(["loginAndSignUp"]);
  return (
    <div className="step-one-cont">
      <div className="mb-4 step-cont-title">
        <Trans i18nKey="loginAndSignUp:surveyStep1">
          Text
          <span className="text-primary step-cont-number fw-bolder">Text </span>
          Text
        </Trans>{" "}
        {t("surveyQuestion")}
      </div>
      <Row gutter={[16, 16]}>
        {purposeList.map(item => (
          <Col xs={12} sm={12} md={8} lg={6} key={item.key}>
            <div
              className={`d-flex flex-column align-items-center justify-content-center position-relative px-2 ${
                stepOneChooseList.indexOf(item.key) !== -1 ? "active" : ""
              }`}
              onClick={() => handleChangeChooseList(item.key)}
            >
              {item.icon()}
              <span className="mt-4 text-center">{item.title}</span>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SurveyStepOneRender;
